//orderSfidを受け取って，そのorderSfidに
// 紐づくorderを取得する関数
export default function (orders, orderSfid) {
  if (orders === undefined || orderSfid === undefined) {
    return
  }
  const foundOrders = orders.filter((order) => order.orderSfid === orderSfid)
  return foundOrders
}
